import { Col, Form, Row, Select, Input, DatePicker } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  GET_BUYER_ENDPOINT,
  GET_BUYING_OFFICE_ENDPOINT,
  SALES_CONTRACT_LIST,
  STYLE_MERCHANDISING_LIST,
  GET_SUPPLIER_ENDPOINT,
  ALL_SALES_CONTRACT_LIST,
} from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
import CustomDatePicker from "common/CustomDatePicker";
const ImportDetailFilterFields = ({ initialTableData, setSupplierType }) => {
  const { Option } = Select;
  const { supplierTypeId } = useParams();
  const isForeign = Number(supplierTypeId) === 0;
  const [salseCotractList, setSalseCotractList] = useState([]);
  const [supplierList, setSupplierList] = useState([]);

  const supplierTypes = [
    { id: 0, value: "Foreign" },
    { id: 1, value: "Local" },
    { id: 2, value: "EPZ" },
  ];

  useEffect(() => {
    if (isForeign) {
      getSalseCotractList();
    }
    getSupplierList();
  }, [isForeign]);

  const getSalseCotractList = async () => {
    let res = await getData(ALL_SALES_CONTRACT_LIST);

    if (res) {
      setSalseCotractList(res?.data?.data || []);
    }
  };

  const getSupplierList = async () => {
    let res = await getData(GET_SUPPLIER_ENDPOINT);

    if (res) {
      setSupplierList(res?.data?.data?.data || []);
    }
  };
  return (
    <>
      <Col className="gutter-row" span={3}>
        <Form.Item
          label="Type of Shipment"
          name="position_type"
          rules={[
            {
              required: false,
              message: "Type is required",
            },
          ]}
        >
          <Select placeholder="Type of Shipment" style={{ width: "100%" }} size="small">
            <option value="LC">LC</option>
            <option value="RTGS">RTGS</option>
            <option value="FOC">FOC Bulk</option>
            <option value="FOC Courier">FOC Courier</option>
            <option value="TT">TT</option>
          </Select>
        </Form.Item>
      </Col>

      <Col span={3}>
        <Form.Item label="Invoice Number" name="invoice_number">
          <Input placeholder="Write Invoice Number" size="small" />
        </Form.Item>
      </Col>
      <Col span={3}>
        <Form.Item label="LC Number" name="b2b_lc_number">
          <Input placeholder="Write LC Number" size="small" />
        </Form.Item>
      </Col>
      {isForeign && (
        <Col span={3}>
          <Form.Item label="Sales Contract" name="sales_contract_id">
            <Select
              allowClear
              showSearch
              placeholder="Select sales contract"
              style={{ width: "100%" }}
              optionFilterProp="children"
              size="small"
            >
              {salseCotractList?.map((contract) => (
                <Option value={contract.id} key={contract.id}>
                  {contract.reference_no}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      )}
      <Col span={3}>
        <Form.Item label="Import Quantity" name="quantity_ctn">
          <Input placeholder="Write Import Quantity" size="small" />
        </Form.Item>
      </Col>
      <Col span={3}>
        <Form.Item label="Invoice Quantity" name="quantity_yds">
          <Input placeholder="Write Invoice Quantity" size="small" />
        </Form.Item>
      </Col>
      <Col span={3}>
        <Form.Item label="Invoice Value" name="invoice_value">
          <Input placeholder="Write Invoice Value" size="small" />
        </Form.Item>
      </Col>
      <Col span={3}>
        <Form.Item label="From Date" name="from_date">
          <CustomDatePicker placeholder="From Date" size="small" />
        </Form.Item>
      </Col>
      <Col span={3}>
        <Form.Item label="To Date" name="to_date">
          <CustomDatePicker placeholder="To Date" size="small" />
        </Form.Item>
      </Col>
    </>
  );
};

export default ImportDetailFilterFields;
